import axios from "axios";
import { store } from "../redux/store";
import { setTimezone } from "../redux/globalDataSlice";

const BASE_URL = import.meta.env.VITE_API_URL;
const API_LOGIN_URL = import.meta.env.VITE_API_LOGIN_URL;
const TIMEOUT = 15000;

function buildLoginRedirectUrl() {
    const uiRedirectUrl = window.location.href;
    // BASE_URL includes nginx prefix (e.g. //app-api.myfth.in/apisvc)
    // API_LOGIN_URL is the login path (e.g. /api/login?redirect=)
    // Together they form the correct backend login URL through nginx
    return `${window.location.protocol}${BASE_URL}${API_LOGIN_URL}${encodeURIComponent(uiRedirectUrl)}`;
}

function isAuthHtmlResponse(response) {
    const contentType = response?.headers?.["content-type"] || "";
    const responseUrl = response?.request?.responseURL || "";

    return (
        contentType.includes("text/html") ||
        responseUrl.includes("/auth/realms/") ||
        responseUrl.includes("/protocol/openid-connect/auth")
    );
}

function getAccessToken() {
    return localStorage.getItem("accessToken");
}

function getSignedVoucher() {
    return localStorage.getItem("signed-voucher");
}


const api = axios.create({
    baseURL: BASE_URL,
    timeout: TIMEOUT,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-App-Name": "dynamic-pricing-rule-studio"
    }
});

export async function apiRequest(config) {
    if (!navigator.onLine) {
        throw { message: "No internet connection", offline: true };
    }

    try {
        const token = getAccessToken();

        const signedVoucher = getSignedVoucher();

        const response = await api({
            ...config,
            withCredentials: true,
            headers: {
                ...config.headers,
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                ...(signedVoucher ? { "signed-voucher": signedVoucher } : {}),
            }
        });

        if (isAuthHtmlResponse(response)) {
            if (getSignedVoucher()) return;
            localStorage.clear();
            store.dispatch(setTimezone(null));
            window.location.href = buildLoginRedirectUrl();
            return;
        }


        return response.data;

    } catch (error) {
        if (!error.response || error.response.status === 401) {
            if (!getSignedVoucher()) {
                localStorage.clear();
                store.dispatch(setTimezone(null));
                window.location.href = buildLoginRedirectUrl();
                return;
            }
            console.log(error);
        }

        /* ===== API Error ===== */
        throw {
            status: error.response?.status,
            message: error.response?.data?.message || (typeof error.response?.data === "string" && error.response?.data) || error.response?.data?.error ||error.response?.statusText || "Server error",
            errors: error.response?.data?.errors
        };
    }
}
